import SilentSubmitHandler from './SilentSubmitHandler';

export default SilentSubmitHandler;
